<template>
  <div>
    <h1 class="adsimple-321825870">Legal Notice</h1>
    <p class="adsimple-321825870">
      Information in accordance with §5 of the E-Commerce Act, §14 of the
      Unternehmensgesetzbuch, §63 of the Commercial Code and disclosure
      requirements under §25 of the Media Act.
    </p>
    <p class="adsimple-321825870">
      Paradise Studio<br />Merseburger Str. 120, <br />04177 Leipzig,
      <br />Deutschland
    </p>
    <p class="adsimple-321825870"></p>
    <p class="adsimple-321825870">
      <strong>Phone:</strong> 01625790189<br />
      <strong>Email:</strong>
      <a href="mailto:hallo@paradisestudio.de">hallo@paradisestudio.de</a>
    </p>
    <p class="adsimple-321825870">
      <strong>Job title:</strong> Webdesigner, Webentwickler
    </p>
    <h2 id="bildernachweis-en" class="adsimple-321825870"></h2>
    <h2 id="urheberrechtshinweis-en" class="adsimple-321825870"></h2>
    <h2 id="haftung-links-webseite-en" class="adsimple-321825870"></h2>
    <h2
      id="haftung-fuer-inhalte-dieser-webseite-en"
      class="adsimple-321825870"
    ></h2>
    <h2 id="eu-streitschlichtung-en" class="adsimple-321825870"></h2>
    <p>All texts are copyrighted.</p>
    <p style="margin-top: 15px">
      Source: Created with the
      <a
        href="https://www.adsimple.de/impressum-generator/"
        title="Impressum Generator by AdSimple for Germany"
        >Impressum Generator</a
      >
      by AdSimple
    </p>
    <p>All texts are copyrighted.</p>
    <p style="margin-top: 15px">
      Source: Created with the
      <a
        href="https://www.adsimple.de/datenschutz-generator/"
        title="Datenschutz Generator by AdSimple for Germany"
        >Datenschutz Generator</a
      >
      by AdSimple
    </p>

    <h1 class="adsimple-321825870">Impressum</h1>
    <p class="adsimple-321825870">
      Informationspflicht laut §5 E-Commerce Gesetz, §14 Unternehmensgesetzbuch,
      §63 Gewerbeordnung und Offenlegungspflicht laut §25 Mediengesetz.
    </p>
    <p class="adsimple-321825870">
      Paradise Studio<br />Merseburger Str. 120, <br />04177 Leipzig,
      <br />Deutschland
    </p>
    <p class="adsimple-321825870"></p>
    <p class="adsimple-321825870">
      <strong>Tel.:</strong> 01625790189<br />
      <strong>E-Mail:</strong>
      <a href="mailto:hallo@paradisestudio.de">hallo@paradisestudio.de</a>
    </p>
    <p class="adsimple-321825870">
      <strong>Berufsbezeichnung:</strong> Webdesigner, Webentwickler
    </p>
    <h2 id="bildernachweis" class="adsimple-321825870">Bildernachweis</h2>
    <p>
      Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich
      geschützt.
    </p>
    <p>Die Bilderrechte liegen bei den folgenden Fotografen und Unternehmen:</p>
    <ul class="adsimple-321825870">
      <li class="adsimple-321825870">Fotograf Mustermann</li>
    </ul>
    <h2 id="urheberrechtshinweis" class="adsimple-321825870">
      Urheberrechtshinweis
    </h2>
    <p>
      Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen
      dem Urheberrecht. Bitte fragen Sie uns bevor Sie die Inhalte dieser
      Website verbreiten, vervielfältigen oder verwerten wie zum Beispiel auf
      anderen Websites erneut veröffentlichen. Falls notwendig, werden wir die
      unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich
      verfolgen.
    </p>
    <p>
      Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht
      verletzen, bitten wir Sie uns zu kontaktieren.
    </p>
    <h2 id="haftung-links-webseite" class="adsimple-321825870">
      Haftung für Links auf dieser Webseite
    </h2>
    <p>
      Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir
      nicht verantwortlich sind. Haftung für verlinkte Websites besteht für uns
      nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben,
      uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir
      Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.
    </p>
    <p>
      Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir
      Sie uns zu kontaktieren. Sie finden die Kontaktdaten im Impressum.
    </p>
    <h2 id="haftung-fuer-inhalte-dieser-webseite" class="adsimple-321825870">
      Haftung für Inhalte dieser Website
    </h2>
    <p>
      Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns
      korrekte und aktuelle Informationen bereitzustellen. Leider können wir
      keine Haftung für die Korrektheit aller Inhalte auf dieser Website
      übernehmen, speziell für jene, die seitens Dritter bereitgestellt wurden.
      Als Diensteanbieter sind wir nicht verpflichtet, die von ihnen
      übermittelten oder gespeicherten Informationen zu überwachen oder nach
      Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
    </p>
    <p>
      Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung
      der Nutzung von Informationen nach den allgemeinen Gesetzen aufgrund von
      gerichtlichen oder behördlichen Anordnungen bleiben auch im Falle unserer
      Nichtverantwortlichkeit davon unberührt.
    </p>
    <p>
      Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte
      wir Sie uns umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte
      entfernen können. Sie finden die Kontaktdaten im Impressum.
    </p>
    <h2 id="eu-streitschlichtung" class="adsimple-321825870">
      EU-Streitschlichtung
    </h2>
    <p>
      Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten
      (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform
      (OS-Plattform) informieren.<br />
      Verbraucher haben die Möglichkeit, Beschwerden an die Online
      Streitbeilegungsplattform der Europäischen Kommission unter
      <a
        class="adsimple-321825870"
        href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=DE"
        target="_blank"
        rel="noopener"
        >http://ec.europa.eu/odr?tid=321825870</a
      >
      zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in
      unserem Impressum.
    </p>
    <p>
      Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder
      verpflichtet sind, an Streitbeilegungsverfahren vor einer
      Verbraucherschlichtungsstelle teilzunehmen.
    </p>
    <p>Alle Texte sind urheberrechtlich geschützt.</p>
    <p style="margin-top: 15px">
      Quelle: Erstellt mit dem
      <a
        href="https://www.adsimple.de/impressum-generator/"
        title="Impressum Generator von AdSimple für Deutschland"
        >Impressum Generator</a
      >
      von AdSimple
    </p>
    <p>Alle Texte sind urheberrechtlich geschützt.</p>
    <p style="margin-top: 15px">
      Quelle: Erstellt mit dem
      <a
        href="https://www.adsimple.de/datenschutz-generator/"
        title="Datenschutz Generator von AdSimple für Deutschland"
        >Datenschutz Generator</a
      >
      von AdSimple
    </p>
  </div>
</template>

<script>
export default {
  name: "Impressum",
};
</script>

<style scoped></style>
